import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  getProductClass,
  getProductSubClasses,
} from "../../../services/productClass";
import { IS_LOCAL_ENV } from "../../../App";
import LoadingPage from "../../../components/LoadingPage";
import CommonTitle from "../../../components/CommonTitle";
import { MdCategory, MdOutlineCategory } from "react-icons/md";
import ProductSubClassForm from "./ProductSubClassForm";
import ProductSubClassCard from "../../../components/ProductClasses/ProductSubClasses/ProductSubClassCard";
import InDevelopment from "../../InDevelopment";
import ModalStructure from "../../../components/ModalStructure";
import EmptyData from "../../EmptyData";

const ProductSubClasses = () => {
  const params = useParams();
  const { productClassId } = params;
  console.log("productClassId", productClassId);
  const [loading, setLoading] = useState(true);
  const [showModalSubClass, setShowModalSubClass] = useState(false);
  const [productClasses, setProductClasses] = useState([]); //para el modal
  const [productClass, setProductClass] = useState(null);
  const [productSubClasses, setProductSubClasses] = useState(null);

  useEffect(() => {
    setLoading(true);
    const fetchClass = async (productClassId) => {
      try {
        const doc = await getProductClass(productClassId);
        IS_LOCAL_ENV && console.log("doc", doc);
        setProductClass(doc);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        IS_LOCAL_ENV && console.error(err);
      }
    };

    const fetchSubClasses = async (productClassId) => {
      try {
        IS_LOCAL_ENV && console.log("productClassId", productClassId);
        const { docs } = await getProductSubClasses(productClassId);
        setProductSubClasses(docs || []);
        setLoading(false);
        IS_LOCAL_ENV && console.log("docs: ", docs);
      } catch (err) {
        setLoading(false);
        IS_LOCAL_ENV && console.error(err);
      }
    };

    fetchClass(productClassId);
    fetchSubClasses(productClassId);
    setLoading(false);
  }, [productClassId]);

  // const loadToParent = (newObj, prevId) => {
  //   let temp = [...productSubClasses];
  //   if (!prevId) {
  //     temp.push(newObj);
  //     setProductSubClasses(temp);
  //   } else {
  //     const prevIndex = temp.findIndex((obj) => obj.id == prevId);
  //     if (prevIndex == -1) return;
  //     temp[prevIndex] = newObj;
  //     setProductSubClasses(temp);
  //   }
  // };

  const [updateKey, setUpdateKey] = useState(0);

  const loadToParent = (newObj, prevId) => {
    setProductSubClasses((prev) => {
      const newList = prevId
        ? prev.map((obj) => (obj.id === prevId ? newObj : obj))
        : [...prev, newObj];

      return newList;
    });

    setUpdateKey((prev) => prev + 1); // Cambia un estado, forzando el re-render
  };

  // if (!IS_LOCAL_ENV) return <InDevelopment />;
  // else
  return (
    <div className="w-full h-full flex flex-col">
      {!(productClass && productSubClasses) ? (
        <LoadingPage />
      ) : (
        <>
          <CommonTitle
            img={`${process.env.REACT_APP_SERVER}${productClass.image.url}`}
            title={productClass.name}
            text="Visualiza y administra las sub-clases"
          >
            <button
              className={` w-fit bg-accent-green text-base m-1 rounded-full py-4 px-6 text-white hover:bg-dark-green transition-all duration-100 font-bold font-poppins `}
              onClick={() => setShowModalSubClass(true)}
            >
              <div className="flex flex-row items-center">
                <span className="text-nowrap">Añadir Subclase</span>
                <MdOutlineCategory />
              </div>
            </button>
            {showModalSubClass && (
              <ModalStructure
                customMaxW={"!max-w-[550px]"}
                handleCloseModal={() => setShowModalSubClass(false)}
              >
                <ProductSubClassForm
                  loadToParent={loadToParent}
                  classId={productClassId}
                  handleClose={() => setShowModalSubClass(false)}
                />
              </ModalStructure>
            )}
          </CommonTitle>

          <div className="flex w-full h-full justify-center">
            <div
              className="flex max-w-[1280px] w-full flex-wrap justify-center gap-4 p-4"
              key={updateKey}
            >
              {productSubClasses.length == 0 && <EmptyData />}
              {productSubClasses.map((subclass, i) => {
                return (
                  <ProductSubClassCard
                    loadToParent={loadToParent}
                    classId={productClassId}
                    info={subclass}
                  />
                );
              })}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ProductSubClasses;
